String.prototype.equalIgnoreCase = function(str)
{
    return (str != null
            && typeof str === 'string'
            && this.toUpperCase() === str.toUpperCase());
};

Element.prototype.remove = function()
{
    this.parentElement.removeChild(this);
}

Element.prototype.addClass = function(name)
{
    if (this.classList) {
    	if (this.classList.contains(name) === false) this.classList.add(name);
    } else if (this.className.contains(name) === false) {
        this.className += ` ${name}`;
    }
    return this;
};

Element.prototype.removeClass = function(name)
{
    if (this.classList) {
        this.classList.remove(name);
    } else {
        this.className = this.className.replace(new RegExp('(^|\\b)' + name.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
    return this;
};

Element.prototype.hasClass = function(name)
{
  if (this.classList)
  {
    return this.classList.contains(name);
  }
  return new RegExp('(^| )' + name + '( |$)', 'gi').test(this.className);
};

Element.prototype.toggleClass = function(name)
{
    if(this.hasClass(name)) {
      this.removeClass(name);
    } else {
      this.addClass(name);
    }
    return this;
};

Element.prototype.getPosition = function()
{
  let el = this;
  let lx = 0;
  let ly = 0;

  for (
      ;

      el != null;

      lx += el.offsetLeft,
      ly += el.offsetTop,
      el = el.offsetParent);

  return {
     x: lx,
     y: ly
  };
}

Element.prototype.getScreenPosition = function()
{
  let el = this;
  let lx = 0;
  let ly = 0;

  for (
      ;

      el != null;

      lx += el.offsetLeft,
      ly += el.offsetTop,
      el = el.parentElement){
      	lx -= el.scrollLeft;
        ly -= el.scrollTop;
      }

  return {
     x: lx - document.documentElement.scrollLeft,
     y: ly - document.documentElement.scrollTop
  };
}

Element.prototype.getInnerSize = function() 
{
  try {
   return {
      width: parseInt(window.getComputedStyle(this, null).getPropertyValue('width'), 10),
      height: parseInt(window.getComputedStyle(this, null).getPropertyValue('height'), 10)
    };
  } catch(e) {
    return {
       width: parseInt(this.currentStyle.width, 10),
       height: parseInt(this.currentStyle.height, 10)
     };
  }
}

Element.prototype.getOuterSize = function() 
{
  return {
     width: parseInt(this.offsetWidth, 10),
     height: parseInt(this.offsetHeight, 10)
   };
}
